import CheckboxGroup from './checkbox-group.vue'
export type { CheckboxGroupProps } from './props'
export default CheckboxGroup